import Vue from "vue";

export default {

    filtraConvocadosMudancaCurso(paramsFiltro, pagina, numElementosPagina, ordenacao) {
        return Vue.axios.post("implantacaoMudancaCurso/convocados/filtro", {
            params: {
                processoOid: paramsFiltro.processoOid,
                cpf: paramsFiltro.cpf,
                nome: paramsFiltro.nome,
                implantado: paramsFiltro.implantado
            },
            pagina,
            numElementosPagina,
            ordenacao
        });
    },

    alterarStatusConvocacao(processoOid, status) {
        return Vue.axios.patch("implantacaoMudancaCurso/convocados/"+ processoOid + "/", null,
            {
            params: {
                status: status
            }
        })
    },

    enviarParaImplantacao(processoOid) {
        return Vue.axios.post("implantacaoMudancaCurso/" + processoOid + "/enviarImplantacao")
    }
}
